import { AutogenLayoutBulkUpdatesConfirmation } from "./autogen/AutogenLayoutBulkUpdatesConfirmation";

export class BulkUpdatesConfirmation extends AutogenLayoutBulkUpdatesConfirmation {
    
}
